/* eslint-disable i18next/no-literal-string */
import { Box, Divider, Typography } from '@mui/material';
import { memo } from 'react';
import { Link } from 'react-router-dom';

import useIntegrationSellerDocsPage from 'pages/IntegrationPage/hooks/useIntegrationSellerDocsPage';
import {
  getRouteSellerIntegrationsSellerConfigPage,
  getRouteSellerIntegrationsSellerReqsPage,
} from 'shared/constants/routerConst';
import { SwaggerDisplay } from 'shared/ui/SwaggerDisplay';

export const IntegrationSellerDocsPage = memo(() => {
  const { sellerId, isLoading, sellerSwagger } = useIntegrationSellerDocsPage();

  const sellerConfigLink =
    getRouteSellerIntegrationsSellerConfigPage(sellerId) + '#seller-api-config';
  const sellerReqsLink =
    getRouteSellerIntegrationsSellerReqsPage(sellerId) +
    '#seller-api-authentication';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        maxWidth: '1460px',
      }}
    >
      <Typography component="h2" typography="openSans.h2">
        {'Seller API Documentation'}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          marginBottom: '20px',
        }}
      >
        <Typography>
          This Swagger outlines the expectations for your Seller API that RE-OPS
          will call. There are a number of optional APIs and fields. Your
          implementation will vary depending on what your system supports. If
          you have any questions about requirements, please contact your RE-OPS
          representative.
        </Typography>
        <Typography>
          RE-OPS can support a number of methods for authenticating with your
          Seller API (documented <Link to={sellerReqsLink}>here</Link> and
          configured <Link to={sellerConfigLink}>here</Link>).
        </Typography>
        <Divider sx={{ margin: '20px 0' }} />
      </Box>
      <Typography
        component="h2"
        typography="openSans.h2"
        sx={{ marginBottom: '0' }}
      >
        {'Seller API Swagger Specifications'}
      </Typography>
      <SwaggerDisplay swaggerJson={sellerSwagger} isLoading={isLoading} />
    </Box>
  );
});
